import React from "react";
import dataSuccess from "../../data/dataSuccess";
import NavSuccess from "./NavSuccess";
import SuccessTemplateSidebar from "./SuccessTemplateSidebar";
import FileUploaderAuto from "./FileUploaderAuto";

class SuccessBorne extends React.Component {
  constructor(props) {
    super(props);
  }

  render() {
    const bgMobile = `url(${dataSuccess[this.props.success].imgMobile})`;
    const price1 = this.props.result.data["Coût travaux unitaire (€)"];
    const dataBorne = {
      "3 kW": {
        title: "Prise renforcée Hager Witty 3 kW",
        price: "669",
      },
      "7 kW": {
        title: "Borne Hager Witty 7 kW",
        price: "1 599,03",
      },
      "11 kW": {
        title: "Borne Hager triphasée 11 à 22 kW",
        price: "2499",
      },
      "22 kW": {
        title: "Borne Hager triphasée 11 à 22 kW",
        price: "2587,85",
      },
      "Je ne sais pas": {
        title: "Borne Hager Witty 7 kW",
        price: "1 599,03",
      },
    };

    const showJENESAISPAS =
      this.props.Q12 == "Je ne sais pas" || this.props.Q12 == "+ 25 mètres";

    return (
      <div className="flex-container">
        <SuccessTemplateSidebar
          success={this.props.success}
          lastStep={this.props.lastStep}
          codePromo={this.props.codePromo}
          handleCodePromo={this.props.handleCodePromo}
          validCodePromo={this.props.validCodePromo}
          resultCodePromo={this.props.resultCodePromo}
        >
          <div className="success-item">
            <h3>
              Distance entre la borne et <br />
              le tableau électrique
            </h3>
            <h2>{this.props.Q12}</h2>
          </div>

          <div className="success-item">
            <h3>Modèle de voiture</h3>
            <h2>{this.props.Q10}</h2>
          </div>
          <div className="success-item">
            <h3>Puissance souhaité</h3>
            <h2>{this.props.Q11}</h2>
          </div>
        </SuccessTemplateSidebar>
        <div className="success-right-container">
          <div className="success-item-right">
            <h5>Estimation des coûts de travaux</h5>
            <div>
              <h5 className="h5-price text-main"> {price1} € </h5>
            </div>
          </div>

          {this.props.resultCodePromo.data.reste_a_charge &&
            this.props.resultCodePromo.data.reste_a_charge !== price1 && (
              <div className="success-item-right">
                <div className="info-block-container">
                  <p className="p">Code Promo</p>
                </div>
                <div>
                  <h5 className="h5-prime">
                    - {this.props.resultCodePromo.data.montant_promo} €{" "}
                  </h5>
                </div>
              </div>
            )}

          {this.props.resultCodePromo.data.reste_a_charge &&
            this.props.resultCodePromo.data.reste_a_charge !== price1 && (
              <div className="success-item-right last">
                <h5>Reste à payer</h5>
                <div>
                  <h5 className="h5-price text-main">
                    {" "}
                    {this.props.resultCodePromo.data.reste_a_charge} €{" "}
                  </h5>
                </div>
              </div>
            )}

          <div style={{ fontWeight: "200", fontSize: "14px" }}>
            <p className="is-hidden-mobile">
              {dataSuccess[this.props.success].paragraph}
            </p>
            <p className="text-main mv-10" style={{ fontWeight: "400" }}>
              Compris dans le prix :
            </p>

            <ul className="borne-list">
              <li>
                <span>+</span>Protection électrique (disjoncteur dédié)
              </li>
              <li>
                <span>+</span>Cable d’alimentation R2V
              </li>
              <li>
                <span>+</span>Installation par nos électrictiens certifiés IRVE
              </li>
            </ul>
          </div>
          <div>
            {this.props.showFile && (
              <FileUploaderAuto
                patchName="fileImposition"
                description="Déposez votre avis imposition pour valider le montant de votre prime"
                handleFile={this.props.handleFile}
                result={this.props.result}
                firstname={this.props.contact.firstname}
                lastname={this.props.contact.lastname}
              ></FileUploaderAuto>
            )}
            <NavSuccess
              callBtn={this.props.callBtn}
              lastStep={this.props.lastStep}
              date={this.props.date}
              creneau={this.props.creneau}
              handleDate={this.props.handleDate}
              handleCreneau={this.props.handleCreneau}
            ></NavSuccess>
          </div>
          <p className="only-show-mobile mb-10" style={{ fontSize: "10px" }}>
            {dataSuccess[this.props.success].paragraph}
          </p>
        </div>
        <div
          style={{
            backgroundImage: bgMobile,
          }}
          className="success-header-img only-show-mobile"
        >
          <h1>{dataSuccess[this.props.success].h1}</h1>
        </div>
      </div>
    );
  }
}

export default SuccessBorne;
